module.exports = __webpack_public_path__ + "media/src/assets/menu_shelters-68fe8d9007b51c221204616e10f76c6a.jpg";